<template>
    <div>
        <modal class="task-payment-record" :display="modalStatus.bizTaskPaymentRecord" @modalStatus="closeModal" >
            <h1>付款紀錄</h1>
            <div class="task-payment-record-wrap">
                <div class="content">
                    <div class="table-title">
                        <div class="date">時間</div>
                        <div class="house-name">房源名稱</div>
                        <div class="payway">付款方式</div>
                        <div class="seq">訂單編號</div>
                        <div class="bonus">金額</div>
                    </div>
                    <div class="table-body" >
                        <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                            <li v-for="(item, index) in list" :key="index">
                                <div class="date">{{getFormatDateTime(item.txnDatetime, true)}}</div>
                                <div class="house-name">{{item.name}}</div>
                                <div class="payway">{{transPayWay(item.paymentType)}}</div>
                                <div class="seq">{{item.taskSeq}}</div>
                                <div class="bonus">{{toCurrency(item.amount)}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizGetTaskPaymentRecord
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            list: [],
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
        }
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        modalStatus: {
            handler: function (val) {
                if(val.bizTaskPaymentRecord){
                    this.getTaskPaymentRecord()
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        getTaskPaymentRecord: function () {
            apiBizGetTaskPaymentRecord()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizTaskPaymentRecord'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.task-payment-record{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 897px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .task-payment-record-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        .table-title{
                            padding: 20px 20px;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                        }
                        .table-body{
                            ul{
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                height: 392px;
                                overflow-x: hidden;
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 16px 20px;
                                    border-bottom: 1px solid #F1F5F4;
                                }
                            }
                        }
                        .table-title .date,
                        .table-body ul li .date{
                            width: 129px;
                            margin-right: 40px;
                        }
                        .table-title .house-name,
                        .table-body ul li .house-name{
                            width: 235px;
                            margin-right: 60px;
                        }
                        
                        .table-title .payway,
                        .table-body ul li .payway{
                            width: 56px;
                            margin-right: 60px;
                        }
                        .table-title .seq,
                        .table-body ul li .seq{
                            width: 101px;
                            margin-right: 68px;
                        }
                        .table-title .bonus,
                        .table-body ul li .bonus{
                            width: 60px;
                            text-align: right;
                        }
                        .table-body ul li .bonus{
                            color: #ff9275;
                        }
                    }
                }
            }
        }
    }
    // @media screen and (max-width: 1280px) {
    //     #modal.task-payment-record{
    //         .modal-content{
    //             width: 1194px;
    //             .detail{
    //                 .task-payment-record-wrap{
    //                     .content{
    //                         .table-title .name,
    //                         .table-body ul li .name{
    //                             width: 160px;
    //                             margin-right: 40px;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/taskPaymentRecord.vue